import React from 'react';
import Card from './Card';

const Bookmark = () => {
  return (
    <div className='container'>
      <h3 className='text-center fw-bolder text-white-50'><i className="fa-solid fa-thumbtack"></i> Bookmarks</h3>
      <div className='row'>
        <Card />
      </div>
    </div>
  )
}

export default Bookmark

